module.exports = __webpack_public_path__ + "static/icon-chopper-ab11051e244a30cb3222b5c68c3fe156.svg";